module.exports = __webpack_public_path__ + "media/home-bg.219fe049.mp4";